
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quotazioni",
      function () {
        return require("private-next-pages/quotazioni/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quotazioni"])
      });
    }
  